import React from 'react';

/**
 * A document's Orcanos key — linked to the item itself when we know where it lives.
 *
 * The key is the one identifier on a quiz screen that means something OUTSIDE this
 * app, so it is the natural way to go and read the document the questions are
 * about. It is one component rather than three copies because the degrade rule is
 * the part worth keeping identical: the URL comes from the training report
 * snapshot, and it can legitimately be absent — an `attention` row that never
 * resolved, or a quiz whose document has dropped out of every built report. Then
 * the key renders as plain text, so nothing ever offers a click that leads nowhere.
 *
 * `stopPropagation` because quiz rows are themselves clickable: without it,
 * opening the document would also navigate the page underneath it.
 */
function DocKeyLink({ docKey, url, className = '' }) {
  if (!docKey) return null;
  const cls = `qz-key${className ? ` ${className}` : ''}`;
  if (!url) return <span className={cls}>{docKey}</span>;
  return (
    <a
      className={`${cls} qz-key-link`}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      title="Open in Orcanos"
      onClick={(e) => e.stopPropagation()}
    >
      {docKey}
    </a>
  );
}

export default DocKeyLink;
